module.exports = __webpack_public_path__ + "/img/Standoff-Male-Female-B1p8gm.svg";